import { useParams } from "react-router-dom";
import MembershipPaymentStatus from "./PaymentStatus";

export default function GetPayment() {
  const { signature, payment: id } =
    useParams<{ signature: string; payment: string }>();

  return <MembershipPaymentStatus id={id} signature={signature} />;
}
